export default "<div id=\"{{target}}\" class=\"map\"></div>";